/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMediaRequest } from '../../models/create-media-request';
import { CreateMediaResponse } from '../../models/create-media-response';

export interface AdminServiceCreateMedia$Params {
      body: CreateMediaRequest
}

export function adminServiceCreateMedia(http: HttpClient, rootUrl: string, params: AdminServiceCreateMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceCreateMedia.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMediaResponse>;
    })
  );
}

adminServiceCreateMedia.PATH = '/api/v3/gateway/admin/media';
